// Copyright (c) 2016 Deere & Company

import LaborAdditivePips from './labor-additive-pips';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.pips.laborAdditive.busyCounter

});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborAdditivePips);



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/index.js